class BackgroundVideo extends HTMLElement {
  #videoElement;
  #posterElement;
  #observer;

  connectedCallback() {
    this.#videoElement = this.querySelector('[data-background-video-media]');
    this.#posterElement = this.querySelector('[data-background-video-poster]');
    if (!this.#videoElement) return;

    // Erst laden und abspielen, wenn das Video in die Nähe kommt; vorher lud autoplay es beim Seitenaufbau (28.10.2026)
    this.#observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.#videoElement.play()?.catch(() => {});
      else this.#videoElement.pause();
    }, { rootMargin: '300px 0px' });
    this.#observer.observe(this);

    if (!this.#posterElement) return;

    if (this.#videoElement.currentTime > 0 && !this.#videoElement.paused) {
      this.hidePoster();
      return;
    }

    this.#videoElement.addEventListener('timeupdate', this.onFirstFrame);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#videoElement?.removeEventListener('timeupdate', this.onFirstFrame);
  }

  hidePoster() {
    this.#posterElement.classList.add('background-video__poster--hidden');
  }

  onFirstFrame = () => {
    if (this.#videoElement.currentTime === 0) return;

    this.hidePoster();
    this.#videoElement.removeEventListener('timeupdate', this.onFirstFrame);
  };
}

if (!customElements.get('background-video')) {
  customElements.define('background-video', BackgroundVideo);
}
